var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinpointBull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "101px",
    viewBox: "0 0 74 101",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svgs/pinpoint-bull") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgs/pinpoint-bull",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3171,10.4733948 C56.425289,12.9279046 61.6566932,17.1028541 65.3519,22.4719913 C69.0225888,27.7929032 70.989485,34.0696565 71,40.4961977 C71,49.1136107 68.2061,54.0472441 61.1845,63.4737734 L37.5,94 L13.8155,63.4935047 C6.7939,54.0472441 4,49.1333447 4,40.5159317 C4.00650769,34.082663 5.97357887,27.7984749 9.6481,22.4719913 C13.3462642,17.1101636 18.5773682,12.9423207 24.6829,10.4931295 C28.7499454,8.85315459 33.1033126,8.00635576 37.5,8 C41.8953581,8 46.2486771,8.84017903 50.3171,10.4733948 Z",
    id: "Vector-14-path-Copy-3",
    fill: "#AF00FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Xnix/Line/Location",
    transform: "translate(23, 28)",
    stroke: "#FBF7EF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.1119996,13.9999492 C3.11297429,8.80562012 6.78301564,4.33530941 11.8777127,3.32283194 C16.97241,2.31035446 22.0728521,5.03769279 24.0598676,9.8369452 C26.0468807,14.6361975 24.3670722,20.1707357 20.047723,23.0559191 C15.7283747,25.941102 9.9724575,25.3733797 6.29999981,21.6999495 C4.25822797,19.6576351 3.111458,16.8878334 3.1119996,13.9999492 L3.1119996,13.9999492 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.334,14.0000204 C9.33461057,11.7740272 10.9075396,9.85843952 13.0908717,9.42472454 C15.2742034,8.99100958 17.4598704,10.1599589 18.3112401,12.2167081 C19.1626089,14.2734575 18.4425712,16.6451925 16.5914605,17.8814921 C14.7403501,19.1177914 12.2737101,18.8743409 10.7000002,17.3000208 C9.82503326,16.4247144 9.3336608,15.2376508 9.334,14.0000204 L9.334,14.0000204 Z",
    id: "Vector-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.888,14 L28,14 M0,14 L3.112,14 M14,3.112 L14,0 M14,28 L14,24.888",
    id: "Vector-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinpointBull);
export default __webpack_public_path__ + "static/media/pinpoint-bull.23acf3a2dfe6a520a4864dceb4e41787.svg";
export { ForwardRef as ReactComponent };